import { AppDispatch, GetAppState, ExtraArgument } from "../store";
import * as organizationUserActions from "../slices/organizationUser";
import { User, Error as APIError } from "../../types/apiv1";

export const getOrganizationUsers = () =>
	async (dispatch: AppDispatch, getState: GetAppState, { api }: ExtraArgument) => {
		const state = getState();

		if (!state.session.authenticated)
			throw new Error("can't get users for an organization when not authenticated");

		dispatch(organizationUserActions.pending());

		let response: User[];
	
		try {
			response = await api.organizations.id(state.session.activeOrganization).organizationusers.get();
		} catch (e) {
			switch (e) {
			case APIError.Network:
				dispatch(organizationUserActions.reset(organizationUserActions.RejectionReason.Network));
				return;
			default:
				dispatch(organizationUserActions.reset(organizationUserActions.RejectionReason.Bug));
				return;
			}
		}

		dispatch(organizationUserActions.ready(response));
	};